module.exports = __webpack_public_path__ + "media/images/common/mypage-5571d53d09c06b42455ce7bacaca4ca3.png";